import { useEffect, useState } from "react"
import { Progress } from "../../interfaces/progress"

type Props = {
    items: Progress[];
    lang: string
}

const TEXT_BY_LANGUAGE = {
    es: {
        completed: "Logros completados"
    },
    pt: {
        completed: "Conquistas concluídas"
    }
}

const ProgressByArea = ({items, lang}:Props) => {
    const [textCompleted, setTextCompleted] = useState("");

    useEffect(() => {
        if(lang === "es"){
            setTextCompleted(TEXT_BY_LANGUAGE.es.completed);
        }

        if(lang === "pt"){
            setTextCompleted(TEXT_BY_LANGUAGE.pt.completed);
        }
    },[lang]);

    return (
        <>
            {items.map((item:Progress, idx: number) => (
                <div className="row mb-2" key={idx}>
                    <div className="col-sm-3 text-center">
                        <img src={item.area.image_url} alt="" width="60" height="auto"
                        title={item.area.name}/>
                    </div>
                    <div className="col-sm-9">
                        <p className="text-left custom-font pt-2"
                        style={{color: "#737373", fontSize: 24}}>{item.completed} de {item.area_total} {textCompleted}</p>
                    </div>
                </div>
            ))}
        </>
    )
}

export default ProgressByArea
